import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ShoppingCartIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M6.80005 17.25C7.07619 17.25 7.30005 17.0261 7.30005 16.75C7.30005 16.4739 7.07619 16.25 6.80005 16.25C6.52391 16.25 6.30005 16.4739 6.30005 16.75C6.30005 17.0261 6.52391 17.25 6.80005 17.25Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.8 17.25C15.0762 17.25 15.3 17.0261 15.3 16.75C15.3 16.4739 15.0762 16.25 14.8 16.25C14.5239 16.25 14.3 16.4739 14.3 16.75C14.3 17.0261 14.5239 17.25 14.8 17.25Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.30005 2.75H4.20914L6.15823 12.5691C6.22474 12.9067 6.40689 13.21 6.67281 13.4258C6.93873 13.6417 7.27147 13.7563 7.61278 13.7497H14.6819C15.0232 13.7563 15.3559 13.6417 15.6218 13.4258C15.8878 13.21 16.0699 12.9067 16.1364 12.5691L17.3 6.41658H4.93641"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
